// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { SimpleModuleDriver } from '../modules/_contracts';
import { AdBannerAdapter, BlockquoteAdapter, DataSetAdapter, EmbedAdapter, GalleryAdapter, HeadingAdapter, HRAdapter, HTMLAdapter, ImageAdapter, ListAdapter, ParagraphAdapter, PaywallAdapter, ReadMoreAdapter, RequestAccessAdapter } from '../modules/front';
/**
 * Associates the ModuleDrivers with the applicable adapters.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
// @ts-expect-error
const adaptersRegistry = {
    [SimpleModuleDriver.AdBanner]: new AdBannerAdapter(),
    [SimpleModuleDriver.Blockquote]: new BlockquoteAdapter(),
    [SimpleModuleDriver.DataSet]: new DataSetAdapter(),
    [SimpleModuleDriver.Embed]: new EmbedAdapter(),
    [SimpleModuleDriver.Form]: new RequestAccessAdapter(),
    [SimpleModuleDriver.Gallery]: new GalleryAdapter(),
    [SimpleModuleDriver.Heading]: new HeadingAdapter(),
    [SimpleModuleDriver.HR]: new HRAdapter(),
    [SimpleModuleDriver.HTML]: new HTMLAdapter(),
    [SimpleModuleDriver.Image]: new ImageAdapter(),
    [SimpleModuleDriver.Legacy]: new HTMLAdapter(),
    [SimpleModuleDriver.List]: new ListAdapter(),
    [SimpleModuleDriver.Paragraph]: new ParagraphAdapter(),
    [SimpleModuleDriver.Paywall]: new PaywallAdapter(),
    [SimpleModuleDriver.ReadMore]: new ReadMoreAdapter()
};
/**
 * Associates the ModuleDrivers with the applicable TokenTypes.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const tokensRegistry = {
    [SimpleModuleDriver.AdBanner]: [TokenType.AdBanner],
    [SimpleModuleDriver.Blockquote]: [TokenType.Blockquote],
    [SimpleModuleDriver.DataSet]: [TokenType.DataSet],
    [SimpleModuleDriver.Embed]: [TokenType.Embed, TokenType.EmbedYouTube, TokenType.EmbedPdf, TokenType.EmbedTwitter, TokenType.EmbedVideo, TokenType.EmbedVideoSwitch],
    [SimpleModuleDriver.Form]: [TokenType.Form],
    [SimpleModuleDriver.Gallery]: [TokenType.Gallery],
    [SimpleModuleDriver.Heading]: [TokenType.Heading],
    [SimpleModuleDriver.HR]: [TokenType.HR],
    [SimpleModuleDriver.HTML]: [TokenType.HTML],
    [SimpleModuleDriver.Image]: [TokenType.Image],
    [SimpleModuleDriver.Legacy]: [TokenType.HTML],
    [SimpleModuleDriver.List]: [TokenType.List],
    [SimpleModuleDriver.Paragraph]: [TokenType.Paragraph],
    [SimpleModuleDriver.Paywall]: [TokenType.Paywall],
    [SimpleModuleDriver.ReadMore]: [TokenType.ReadMore]
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class SimpleModuleAdapter {
    constructor() {
        this.adaptersRegistry = adaptersRegistry;
        this.tokensRegistry = tokensRegistry;
    }
    /**
     * Adapts (translates/maps) the passed-in module object to `Token`.
     *
     * @param object - The object to adapt.
     * @param storage
     */
    objectToToken(object, storage) {
        const adapter = this.adaptersRegistry[object.driver];
        if (typeof adapter === 'undefined') {
            throw new Error(`Adapter.objectToToken(): No Adapter was found for the given driver!\nObject: ${JSON.stringify(object)}`);
        }
        return adapter.objectToToken(object, storage);
    }
    /**
     * Adapts (translates/maps) the passed-in `Token` to module object.
     *
     * @param token - The Token to adapt.
     * @param storage
     */
    tokenToObject(token, storage) {
        let driver;
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const drivers = Object.values(SimpleModuleDriver);
        for (const _driver of drivers) {
            if (Object.prototype.hasOwnProperty.call(this.tokensRegistry, _driver)) {
                if (this.tokensRegistry[_driver].includes(token.type)) {
                    driver = _driver;
                    break;
                }
            }
        }
        if (typeof driver === 'undefined') {
            throw new Error(`Adapter.tokenToObject(): No driver was found for the given token!\nToken: ${JSON.stringify(token)}`);
        }
        const adapter = this.adaptersRegistry[driver];
        if (typeof adapter === 'undefined') {
            throw new Error(`Adapter.tokenToObject(): No Adapter was found for the given token!\nToken: ${JSON.stringify(token)}`);
        }
        return adapter.tokenToObject(token, storage);
    }
}
